import { AnyAction, configureStore, ThunkDispatch } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

const store = configureStore({
  reducer: rootReducer,
});

export default store;
type ReduxState = ReturnType<typeof rootReducer>;
// For calling async Thunk methods. See https://github.com/reduxjs/redux-toolkit/issues/587
// This needs to accept any type of input for various methods.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = ThunkDispatch<ReduxState, any, AnyAction>;
